"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartDataEnum = void 0;
var ChartDataEnum;
(function (ChartDataEnum) {
    ChartDataEnum["portfolioValue"] = "portfolioValue";
    ChartDataEnum["externalValue"] = "externalValue";
    ChartDataEnum["pinnedPortfolioValue"] = "pinnedPortfolioValue";
})(ChartDataEnum = exports.ChartDataEnum || (exports.ChartDataEnum = {}));
//# sourceMappingURL=chart-data-enum.js.map